import { lazy } from 'react';

// Lazy load page components for better code splitting
export const HomePage = lazy(() => import('../pages/HomePage'));
export const QuestionsPage = lazy(() => import('../pages/QuestionsPage'));
export const MatchTherapistHome = lazy(
  () => import('@/pages/MatchTherapistHomepage'),
);
export const ErrorBoundary = lazy(
  () => import('../components/ErrorBoundary/ErrorBoundary'),
);
export const ErrorBoundaryRoutes = lazy(
  () => import('../components/ErrorBoundary/ErrorBoundaryRoutes'),
);

export const BaseUseCaseHandler = lazy(() => import('./BaseUseCaseHandler'));

export const BaseBotHandler = lazy(() => import('./BaseBotHandler'));
